import check from '../../../../../assets/check_new.png'

function DNDPin({ card, elementStyle, changeSelection, language }) {
  return (
    <div
      id="componentContainer"
      data-tour="rpdesigner-step-3"
      style={elementStyle}
      onClick={changeSelection}
    >
      <input
        type="number"
        id="pin"
        name="pin"
        placeholder={card.value[1].languages[language]}
        style={{
          width: card?.inputSize ? card.inputSize + "%" : "100%",
          margin: "5px 0",
          padding: "9px 10px",
          display: "inline-block",
          border: "1px solid #ccc",
          borderRadius: "4px",
          boxSizing: "border-box",
          fontSize: "16px",
        }}
      />
      <button
        type="button"
        id="pinbutton"
        style={{
          width: card?.inputSize ? card.inputSize + "%" : "100%",
          marginBottom: "5px",
          fontWeight: "500",
          fontSize: "0.875rem",
          lineHeight: "1.75",
          letterSpacing: "0.02857em",
          minWidth: "64px",
          padding: "6px 16px",
          borderRadius: "4px",
          color: "#fff",
          backgroundColor: card.buttonColor,
          transition: "all 0.5s",
          border: "0",
          borderTopLeftRadius: card?.buttonLeftRound ? "25px" : "0",
          borderBottomLeftRadius: card?.buttonLeftRound ? "25px" : "0",
          borderTopRightRadius: card?.buttonRightRound ? "25px" : "0",
          borderBottomRightRadius: card?.buttonRightRound ? "25px" : "0",
          cursor: "pointer",
          display: card.enableButton ? "flex" : "none",
          textAlign: card?.buttonTextAlignment
            ? card.buttonTextAlignment
            : "center",
        }}
      >
        <div style={{ flex: "auto" }}>{card.value[2].languages[language]}</div>
        <img src={check} style={{ height: "24px" }} />
      </button>
      <input
        readOnly
        id="pinControl"
        style={{ display: "none" }}
        value="{Serial_5}"
      />
      <input
        readOnly
        id="showTop"
        style={{ display: "none" }}
        value={card.showTop}
      />
      <input
        readOnly
        id="enableButton"
        style={{ display: "none" }}
        value={card.enableButton}
      />
      <input
        readOnly
        id="checkInstantly"
        style={{ display: "none" }}
        value={card.checkInstantly}
      />
      <div id="redirect" style={{ display: "none" }}>
        {card.value[3]?.languages[language]}
      </div>
      <div id="retries" style={{ display: "none" }}>
        {card.retries}
      </div>
      <div id="token" style={{ display: "none" }}>
        {"{CODI-ITEM-TOKEN}"}
      </div>
      <div id="errorMessageRetry" style={{ color: "red" }}>
        {card.value[0].languages[language]}
      </div>
    </div>
  );
}

export default DNDPin;
